import { Slide } from "react-reveal";
import SolutionCard from "../../reusables/SolutionCard";
import web from "../../../assets/images/solutions-icon/web.svg";
import app from "../../../assets/images/solutions-icon/mobile_app.svg";
import ecomm from "../../../assets/images/solutions-icon/ecommerce-website-icon.svg";

const RelatedSystem = () => {
  return (
    <section className="related section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center">
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Related Solutions
                </h2>
              </Slide>
            </div>
            <div className="section-body section-spacing-50 no-padding-top">
              <ul className="solutions-items-container">
                <SolutionCard
                  icon={web}
                  title="Website Design & Development"
                  subtitle="Modern and responsive websites built for performance and scalability"
                  ctaLink="/solutions/website-development"
                />
                <SolutionCard
                  icon={app}
                  title="Mobile App Development"
                  subtitle="Android and iOS apps designed for usability and performance"
                  ctaLink="/solutions/website-development"
                />
                <SolutionCard
                  icon={ecomm}
                  title="E-commerce Solutions"
                  subtitle="Online stores with payment integration and seamless user experience"
                  ctaLink="/solutions/ecommerce"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RelatedSystem;
